import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AlternateFlow,
  NextgenReshopHeader,
  TripData
} from '../../model/global-nav.interfaces';

@Component({
  selector: 'ngc-my-trips-link',
  templateUrl: './my-trips-link.component.html'
})
export class MyTripsLinkComponent implements OnInit {
  @ViewChild('findTripForm') myTripsSearchForm: ElementRef;
  @Input() findTripData: TripData = {} as TripData;
  @Input() alternateFlow: AlternateFlow = {} as AlternateFlow;
  @Input() alternativeText: string;
  @Input() nextgenReshopHeaderData: NextgenReshopHeader =
    {} as NextgenReshopHeader;

  //TODO: Uncomment below when all components stop sending findTripData as Input
  // findTripData: TripData = {} as TripData;
  TRIP_RETURN_ACTION = '/mytrips/';
  TRIP_ORIGINAL_SOURCE = 'Find+My+Trips';

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    if (!this.findTripData || !this.findTripData.confirmationNo) {
      this.fetchPnrData();
    }
  }

  submitTripsForm() {
    this.myTripsSearchForm.nativeElement.submit();
  }

  fetchPnrData() {
    const cacheKeySuffix =
      this.activatedRoute.snapshot.queryParams.cacheKeySuffix;
    const pnrDataString =
      sessionStorage.getItem(`pnrData${cacheKeySuffix}`) !== null
        ? sessionStorage.getItem(`pnrData${cacheKeySuffix}`)
        : localStorage.getItem(`pnrData${cacheKeySuffix}`);
    if (pnrDataString) {
      const pnrData = JSON.parse(pnrDataString);
      this.findTripData = {
        firstName: pnrData.firstName,
        lastName: pnrData.lastName,
        confirmationNo: pnrData.recordLocatorId,
        returnAction: this.TRIP_RETURN_ACTION,
        originalSource: this.TRIP_ORIGINAL_SOURCE,
        interstitial: true
      };
    }
  }
}
